"use client";

import type { ToolUIRegistry } from "@bg-bgi/magnus-sdk/react";
import { lazy } from "react";

export const webSearchToolRegistry = {
  webSearch: {
    kind: "step",
    category: "web",
    view: lazy(() =>
      import("./web-search").then(({ WebSearchToolView }) => ({
        default: WebSearchToolView,
      }))
    ),
  },
  extractWebContent: {
    kind: "step",
    category: "web",
    view: lazy(() =>
      import("./extract-web-content").then(({ ExtractWebContentToolView }) => ({
        default: ExtractWebContentToolView,
      }))
    ),
  },
  mapWebsite: {
    kind: "step",
    category: "web",
    view: lazy(() =>
      import("./map-website").then(({ MapWebsiteToolView }) => ({
        default: MapWebsiteToolView,
      }))
    ),
  },
  crawlWebsite: {
    kind: "step",
    category: "web",
    view: lazy(() =>
      import("./crawl-website").then(({ CrawlWebsiteToolView }) => ({
        default: CrawlWebsiteToolView,
      }))
    ),
  },
} satisfies ToolUIRegistry;
